// GENERATED FILE - DO NOT MODIFY

export enum GetCompaniesSortColumnDto {
    Name = "Name",
    LocationName = "LocationName",
    Status = "Status",
    MembersCount = "MembersCount",
    Type = "Type",
}